import { useRef, useEffect } from 'react';
import moment from 'moment';
import { getEventCategoryColor } from '../CategoryLegend/themedCategoryColors';

// Get the effective calendar color for an event (custom color overrides original)
export const getEffectiveCalendarColor = (event, customCalendarColors = {}) => {
    if (!event) return null;
    // Build the calendar key from event's primary_email and calendar id
    const calendarKey = event.primary_email && event.calendar
        ? `${event.primary_email}-${event.calendar}`
        : null;
    // Check for custom color first, then fall back to event's stored calendar color
    return (calendarKey && customCalendarColors[calendarKey]) || event.calendarColor || null;
};

export const calcColors = (event, currentView, selectedEvent, themeName = null, customCalendarColors = {}) => {
    const isSelected = selectedEvent && selectedEvent.id === event.id;
    // Use themed category color if available, otherwise fall back to stored color
    const categoryColor = themeName ? getEventCategoryColor(event, themeName) : null;
    // Get effective calendar color (custom overrides original)
    const effectiveCalendarColor = getEffectiveCalendarColor(event, customCalendarColors);
    const eventColor = categoryColor || event.color || effectiveCalendarColor || '#3174ad';
    const selectedRingStyle = isSelected ? { '--selected-ring-color': eventColor } : {};
    const colors = {
        style: {
            '--event-color': eventColor,
            display: 'visible' in event ? (event.visible ? 'block' : 'none') : 'block',
            ...selectedRingStyle,
        },
        ...(event.isDraggable
            ? { className: isSelected ? 'isDraggable isSelectedEvent' : 'isDraggable' }
            : { className: isSelected ? 'nonDraggable isSelectedEvent' : 'nonDraggable' }),
    };
    return colors;
}


export const isAllDay = (event) => {
    // TODO: should trust event.isAllDayevent.start && event.end
    if (!event) {
        return false;
    }
    if ('isAllDay' in event && event.isAllDay) {
        return true;
    }
    // console.log('time', event)
    if ('start' in event && 'end' in event && event.start && event.end) {
        const duration = moment.duration(moment(event.end).diff(moment(event.start)));
        const minutes = duration.asMinutes();
        // console.log('time duration', duration)
        // console.log('time minutes', minutes)

        if (minutes >= (24 * 60 - 1)) {
            return true;
        }
    }
    return false;
}


export const updateBackgroundCSSRules = (backgroundColor, cssRuleNumber, setCssRuleNumber) => {
    // TODO: not sure we're event using it anymore as each event has its color / calendar color
    // TODO: exception on server: react-dom.production.min.js:189 DOMException: Failed to execute 'insertRule' on 'CSSStyleSheet': Failed to insert the rule.
    // let stylesheet = document.styleSheets[0];
    // stylesheet.insertRule(`.rbc-toolbar-label {color: ${backgroundColorCalendar}}`);
    // stylesheet.insertRule(`.rbc-toolbar-label {color: ${backgroundColor}}`);
    // stylesheet.insertRule(`.rbc-event.isDraggable {background-color: ${backgroundColor}}`, cssRuleNumber);
    // stylesheet.insertRule(`.rbc-event.nonDraggable {background-color: ${backgroundColor}}`, cssRuleNumber + 1);
    // setCssRuleNumber(cssRuleNumber + 2);

    const styleSheet = document.createElement('style');
    document.head.appendChild(styleSheet);
    styleSheet.textContent = `.rbc-event.isDraggable {background-color: ${backgroundColor}}
                              .rbc-event.nonDraggable {background-color: ${backgroundColor}}`;

  }
  
export const  updateTimes = (currentView, setCurrentView, currentDate, setCurrentDate) => {
    // let start, end;
    // // if view is day: from moment(date).startOf('day') to moment(date).endOf('day');
    // if(view === 'day'){
    //   start = moment(date).startOf('day');
    //   end   = moment(date).endOf('day');
    // }
    // // if view is week: from moment(date).startOf('isoWeek') to moment(date).endOf('isoWeek');
    // else if(view === 'week'){
    //   start = moment(date).startOf('isoWeek');
    //   end   = moment(date).endOf('isoWeek');
    // }
    // //if view is month: from moment(date).startOf('month').subtract(7, 'days') to moment(date).endOf('month').add(7, 'days'); i do additional 7 days math because you can see adjacent weeks on month view (that is the way how i generate my recurrent events for the Big Calendar, but if you need only start-end of month - just remove that math);
    // else if(view === 'month'){
    //   start = moment(date).startOf('month').subtract(7, 'days');
    //   end   = moment(date).endOf('month').add(7, 'days');
    // }
    // // if view is agenda: from moment(date).startOf('day') to moment(date).endOf('day').add(1, 'month');
    // else if(view === 'agenda'){
    //   start = moment(date).startOf('day');
    //   end   = moment(date).endOf('day').add(1, 'month');
    // }
}

export const setCurrentUserCalendarAndSelectionColors = (setCurrentUserCalendar, calAccountIdentifierWithDivider, calendar) => {
    // TODO: update this at start of program when we setCalendars
    setCurrentUserCalendar(calAccountIdentifierWithDivider);
    document.documentElement.style.setProperty('--color-scheme-time-selection', calendar.backgroundColor);
    document.documentElement.style.setProperty('--color-scheme-time-selection-color', calendar.foregroundColor);
}

    // TODO  https://github.com/jquense/react-big-calendar/issues/1217
  // const eventWrapper = (props) => {
  //   // Some data that you might have inserted into the event object
  //   const data = props.event;
  //   console.log('data', data)
  //   const customDiv = (
  //     <div className="yourClass">
  //       <span>{data.someField}</span>
  //       <span>{data.anotherField}</span>
  //     </div>
  //   );
  //   const eventDiv = React.cloneElement(props.children.props.children, {}, customDiv);
  //   const wrapper = React.cloneElement(props.children, {}, eventDiv);
  //   return (<div>
  //     {wrapper}
  //   </div>
  //   )}


// TODO: change resize anchor(s)
  // https://github.com/jquense/react-big-calendar/blob/209de9b7d02193ad3f87a5fca62a73055fce2c2c/src/addons/dragAndDrop/EventWrapper.js